import { SAVE_CLIENT_TREATMENT_PLAN_SIGN } from "../actions/types";

const initialState = {
  signatureOwner: {},
};

export const TreatmentPlanSignReducer = (state = initialState, action: any) => {
  const oldState = { ...state };
  const { type, payload } = action;
  switch (action.type) {
    case SAVE_CLIENT_TREATMENT_PLAN_SIGN:
      return {
        ...state,
        signatureOwner: payload,
      };
    default:
      return { ...state };
  }
};
